import { render, staticRenderFns } from "./AccountTwoFaSetup.vue?vue&type=template&id=4c214941"
import script from "./AccountTwoFaSetup.vue?vue&type=script&lang=js"
export * from "./AccountTwoFaSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports